import React from 'react';
import PictureFrame from '../../PictureFrame/PictureFrame.jsx';
import MobileDetect from 'mobile-detect';

export default class FuelInset extends React.Component {
    componentDidMount() {
        let mobiledetect = new MobileDetect(navigator.userAgent||navigator.vendor||window.opera);
        if(mobiledetect.mobile()) {
            this.refs.innerdiv.innerHTML = '<img src="images/gloop.gif" style="width:100%">';
        } else {
            this.refs.innerdiv.innerHTML = '<video src="videos/gloop.mp4" style="width:100%;margin-top:-2px;" autoplay muted loop></video>';
        }
    } 
    render()  {
        return <div>
            <PictureFrame caption="Marine fuels are classified by their viscosity. Pictured are a low-sulfur distillate (left, low viscosity) and a high-sulfur residual fuel oil (right, high viscosity).">
                <div ref="innerdiv" style={{overflow:"hidden"}}/>       
            </PictureFrame>
        </div>
    }
}
/*<img style={{width:"100%"}} src="images/multibottle.png"/>*/

/*

<div className="row">
                <div className="col l6 m6 s12">
                    <PictureFrame caption="Residual, or bunker fuels, are the leftover by-products of the distillation process. The pictured fuel grade ranges from XX% to XX% sulphur per volume.">
                        <img style={{display:"block",maxWidth:"150px",marginLeft:"auto",marginRight:"auto"}} src="images/bunker.png" />
                    </PictureFrame>    
                </div>
                <div className="col l6 m6 s12">
                    <PictureFrame caption="Distillate fuels, which are extracted earlier in the distillation process than bunker fuels, generally burn cleaner and contain less sulphur. The pictured fuel grade can ranges from XX% to XX% sulphur per volume.">
                        <img style={{display:"block",maxWidth:"159px",marginLeft:"auto",marginRight:"auto"}} src="images/distillate.png" />
                    </PictureFrame>    
                </div>
            </div>
*/


// WEBPACK FOOTER //
// ./src/js/components/special/FuelInset/FuelInset.jsx